import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUser, selectUserEmail } from '../Auth/authSlice';
import { cancelAnketa, fetchMySlots, saveFeedback } from './slotsApi';
import SlotItem from './SlotItem';
import './Slots.css';
import { useNavigate } from 'react-router-dom';
import FeedbackModal from './FeedbackModal';

const MySlots = () => {
    const navigate = useNavigate();
    const user = useSelector(selectUser);
    const [slots, setSlots] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const [showModal, setShowModal] = useState(false);
    const [selectedSlot, setSelectedSlot] = useState(null);

    const formatDate = (isoString) => {
        const date = new Date(isoString);
        return (
            date.toLocaleDateString('ru-RU', {
                weekday: 'short',
                day: '2-digit',
                month: '2-digit',
            }) +
            ' ' +
            date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
        );
    };

    const handleCancelSlot = async (slot) => {
        if (!window.confirm('Вы уверены, что хотите отменить запись?')) return;

        try {
            await cancelAnketa(slot.anket_id);
            setSlots((prevSlots) => prevSlots.filter((s) => s.id !== slot.id));
        } catch (err) {
            alert('Ошибка при отмене записи: ' + err.message);
        }
    };


    const handleGoToAnketa = (slot) => {
        navigate('/anketa', { state: { slot } });
    };

    const handleOpenFeedbackModal = (slot) => {
        setSelectedSlot(slot);
        setShowModal(true);
    };

    const handleSaveFeedback = async (slot, feedbackText) => {
        try {
            await saveFeedback(slot.anket_id, feedbackText);
            setSlots((prevSlots) =>
                prevSlots.map((s) =>
                    s.id === slot.id ? { ...s, feedback: feedbackText } : s
                )
            );
        } catch (err) {
            alert('Ошибка при сохранении отзыва: ' + err.message);
        }
    };

    const handleAnketaClick = (slot) => {
        const hoursLeft = (new Date(slot.datetime) - new Date()) / (1000 * 60 * 60);
        if (hoursLeft < 24) {
            alert('Редактирование анкеты возможно не позднее, чем за 24 часа до начала сеанса.');
        } else {
            handleGoToAnketa(slot);
        }
    };

    useEffect(() => {
        if (!user?.email) return;

        const loadMySlots = async () => {
            try {
                const data = await fetchMySlots(user?.email);
                const slotsWithFormattedDate = data.map((slot) => ({
                    ...slot,
                    formattedDate: formatDate(slot.datetime),
                }));
                setSlots(slotsWithFormattedDate);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        loadMySlots();
    }, [user?.email]);

    // if (!email) return <div>Пожалуйста, авторизуйтесь</div>;
    // if (loading) return <div>Загрузка...</div>;
    // if (error) return <div>Ошибка: {error}</div>;

    return (
        <div>
            <FeedbackModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                onSave={handleSaveFeedback}
                slot={selectedSlot}
            />

            <h2>Мои слоты</h2>
            <div className="myslots-container">
                {slots.length === 0 ? (
                    <div>У вас пока нет записей</div>
                ) : (

                    slots.map((slot) => {
                        const isPast = new Date(slot.datetime) < new Date();
                        const hasFeedback = slot.feedback && slot.feedback.trim() !== '';

                        return (
                            <div key={slot.id} className="slot-item-wrapper">
                                <SlotItem slot={slot} disableBooking my />

                                {isPast ? (
                                    hasFeedback ? (
                                        <div style={{ color: 'gray', fontWeight: 'bold' }}>
                                            Отзыв оставлен
                                        </div>
                                    ) : (
                                        <button
                                            className="btn_anketa"
                                            onClick={() => handleOpenFeedbackModal(slot)}
                                        >
                                            Оставить отзыв
                                        </button>
                                    )
                                ) : slot.status === 'filled' ? (
                                    <>
                                        <div
                                            style={{ color: 'green', fontWeight: 'bold', cursor: 'pointer' }}
                                            onClick={() => handleAnketaClick(slot)}
                                        >
                                            Анкета заполнена
                                        </div>
                                        <button
                                            className="btn_cancel"
                                            onClick={() => handleCancelSlot(slot)}
                                        >
                                            Отменить запись
                                        </button>
                                    </>
                                ) : (
                                    <>
                                        <button
                                            className="btn_anketa"
                                            onClick={() => handleGoToAnketa(slot)}
                                        >
                                            Анкета
                                        </button>
                                        <button
                                            className="btn_cancel"
                                            onClick={() => handleCancelSlot(slot)}
                                        >
                                            Отменить запись
                                        </button>
                                    </>
                                )}
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    );
};

export default MySlots;
